import React from 'react';
import PageHeader from '../components/layout/PageHeader';
import HubSectionCard from '../components/cards/HubSectionCard';
import hubs from '../cms/hubs.json';
import '../css/pages/Events.css';

const Events = () => {
  const hub = hubs.events || {};
  const eventSections = hub.cards || [];

  return (
    <>
      <PageHeader 
        title={hub.pageTitle} 
        subtitle={hub.pageSubtitle}
        showLogo={true}
      />
      
      <div className="events-container">
        <section className="events-sections">
          <div className="sections-grid">
            {eventSections.map((section) => (
              <HubSectionCard key={section.path || section.externalUrl || section.title} card={section} />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Events;
